import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateAnalyticsConsentDocument,
  UpdateAnalyticsConsentMutation,
  UpdateAnalyticsConsentMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateAnalyticsConsentMutation,
  UpdateAnalyticsConsentMutationVariables
>

export const useUpdateAnalyticsConsent = (options?: Options) => {
  const [updateAnalyticsConsent, { loading }] = useMutation(UpdateAnalyticsConsentDocument, {
    ...options,
    extractorFn: (data) => data.apiCoreMutations.updateApicoreAccess,
  })

  return {
    loading,
    update(variables: UpdateAnalyticsConsentMutationVariables) {
      return updateAnalyticsConsent({
        variables,
      })
    },
  }
}
